import { render, staticRenderFns } from "./login_admin.vue?vue&type=template&id=794a59b6&scoped=true&"
import script from "./login_admin.vue?vue&type=script&lang=js&"
export * from "./login_admin.vue?vue&type=script&lang=js&"
import style0 from "./login_admin.vue?vue&type=style&index=0&id=794a59b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a59b6",
  null
  
)

export default component.exports